import styles from "../../styles/analytics/quickStatComponent.module.css";
import { CircularProgress, Paper, Typography } from "@mui/material";
import { ReactJSXElement } from "@emotion/react/types/jsx-namespace";

interface QuickStatComponentProps {
  type: string;
  value: number | ReactJSXElement | string;
  svgIcon?: string;
  loading?: boolean;
  color?: string;
}

export default function QuickStatComponent(props: QuickStatComponentProps) {
  const {
    type = "",
    value = 0,
    svgIcon = "portfolioDashboard.svg",
    loading = false,
    color = "white",
  } = props;

  return (
    <Paper
      elevation={5}
      className={styles.container}
      sx={{ backgroundColor: `${color}` }}
    >
      <img
        src={`${process.env.PUBLIC_URL}/svgs/${svgIcon}`}
        alt="icons"
        loading="lazy"
      />
      <Typography variant="h6" color="inherit">
        {!loading ? value : <CircularProgress sx={{ fontSize: 10 }} />}
      </Typography>
      <Typography variant="body1" sx={{ fontWeight: "bolder" }}>
        {type}
      </Typography>
    </Paper>
  );
}
